

export default class ResizeHandler {
  constructor() {
    this.isResizing = false;
    this.resizeTimeout = null;
  }

  handleResizeStart() {
    try {
      this.isResizing = true;

      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.isResizing = false;
      }, 1000);
    } catch (error) {
      console.error('Error in handleResizeStart:', error);
    }
  }

  preventAfterChangeDuringResize(eventHandler) {
    return (...args) => {
      try {
        if (this.isResizing) {
          console.log('After change event prevented due to resizing');
          return;
        }
        eventHandler(...args);
      } catch (error) {
        console.error('Error in preventAfterChangeDuringResize:', error);
      }
    };
  }

  addResizeListener() {
    try {
      if (!window.enableOEMProgram || !window.enableWebsiteTagging) {
        return;
      }
      window.addEventListener('resize', this.handleResizeStart.bind(this));
    } catch (error) {
      console.error('Error in addResizeListener:', error);
    }
  }

  removeResizeListener() {
    try {
      if (!window.enableOEMProgram || !window.enableWebsiteTagging) {
        return;
      }
      window.removeEventListener('resize', this.handleResizeStart.bind(this));
    } catch (error) {
      console.error('Error in removeResizeListener:', error);
    }
  }
}
